var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/next.e82c8424.png","uri@3x": __webpack_public_path__ + "static/media/next.548845af.png","uri@2x": __webpack_public_path__ + "static/media/next.3eb8cc31.png",
    width: 51,
    height: 49
});